import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import home from '@/components/home'
import CmsPage from '@/components/CmsPage'
import search from '@/components/search'
import { normalizeLegacyRoute } from '@/utils/cmsNav'

Vue.use(Router)

function legacyRedirect(to) {
  return normalizeLegacyRoute(to) || { path: '/cms', query: to.query }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: main,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: home,
        },
        {
          path: '/cms',
          name: 'cms',
          component: CmsPage,
        },
        {
          path: '/search',
          component: search,
        },
        {
          path: '/aboutUs',
          redirect: legacyRedirect,
        },
        {
          path: '/newsCenter',
          redirect: legacyRedirect,
        },
        {
          path: '/investor',
          redirect: legacyRedirect,
        },
        {
          path: '/contactUs',
          redirect: legacyRedirect,
        },
        {
          path: '/vocational',
          redirect: legacyRedirect,
        },
        {
          path: '/copyright',
          redirect: legacyRedirect,
        },
        {
          path: '/construct',
          redirect: legacyRedirect,
        },
      ],
    },
  ],
})

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch((err) => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js